import React from 'react';
import { callNativeMethod } from 'src/mobile-ecomm/hooks/use-mobile-native-bridge';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import useUI from 'hooks/use-ui';
import { Typography } from 'src/typography';
import useTranslation from 'hooks/use-translation';
import { StyledButton } from '../../components';

const PushNotificationSettings = () => {
  const { isMobileEcommAppNotificationsEnabled } = useUI();

  return isMobileEcommAppNotificationsEnabled ? (
    <PushNotificationSettingsEnabled />
  ) : (
    <PushNotificationSettingsDisabled />
  );
};

const PushNotificationSettingsDisabled = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <LineBreak />
      <HeaderText tag='h3' size='xsmall'>
        {(props) => props.t('accountsPage.pushTitle', 'Push Notifications')}
      </HeaderText>
      <BodyText size='medium'>
        {(props) =>
          props.t(
            'accountsPage.enabledBody',
            'Never miss an update! Turn on push notifications to receive the latest information about your order.'
          )
        }
      </BodyText>
      <TurnOnButton onClick={() => callNativeMethod(`onLaunchPushNotifications`)}>
        {t('accountsPage.turnOnNotifications', 'Turn on notifications')}
      </TurnOnButton>
    </Container>
  );
};

const PushNotificationSettingsEnabled = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <LineBreak />
      <HeaderText tag='h3' size='xsmall'>
        {(props) => props.t('accountsPage.pushTitle', 'Push Notifications')}
      </HeaderText>
      <BodyText size='medium'>
        {(props) => props.t('accountsPage.disabledBodyLineOne', 'Push notifications are currently enabled.')}
      </BodyText>
      <BodyText size='medium'>
        {(props) => {
          const text = props.t('accountsPage.disabledBodyLineTwo', 'To turn off push notifications, ');
          const onClick = () => callNativeMethod(`onLaunchPushNotifications`);
          return (
            <span>
              <span>{text}</span>
              <SettingsLink onClick={onClick} onKeyDown={onClick} role='button' tabIndex='0'>
                {t('accountsPage.navigateToSettings', 'navigate to your Settings.')}
              </SettingsLink>
            </span>
          );
        }}
      </BodyText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

const HeaderText = styled(Typography.Heading)`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

const BodyText = styled(Typography.Body)`
  color: ${({ theme }) => theme.colors.grey[45]};
  font-size: 13px;
`;

const TurnOnButton = styled(StyledButton)`
  margin-top: 18px;
`;

const LineBreak = styled.div`
  background-color: ${({ theme }) => theme.colors.grey[90]};
  height: 1px;
  margin: 40px 6px 24px;
`;

const SettingsLink = styled.span`
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};
`;

export default observer(PushNotificationSettings);
